import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type DomainZoneHasDependentsErrorOptions = {
  zone: ObjectId;
};

export class DomainZoneHasDependentsError extends FleekError<DomainZoneHasDependentsErrorOptions> {
  public name = 'DomainZoneHasDependentsError';

  toString = () => 'Domain zone has assigned domains or private gateways. You have to delete them first.';
}
